var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAkarIconsMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 5.83317C1.6665 5.39114 1.8421 4.96722 2.15466 4.65466C2.46722 4.3421 2.89114 4.1665 3.33317 4.1665H16.6665C17.1085 4.1665 17.5325 4.3421 17.845 4.65466C18.1576 4.96722 18.3332 5.39114 18.3332 5.83317V14.1665C18.3332 14.6085 18.1576 15.0325 17.845 15.345C17.5325 15.6576 17.1085 15.8332 16.6665 15.8332H3.33317C2.89114 15.8332 2.46722 15.6576 2.15466 15.345C1.8421 15.0325 1.6665 14.6085 1.6665 14.1665V5.83317Z",
    stroke: "#002E6C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    stroke: "#002E6C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 7.49984C2.55056 7.49984 3.39841 7.14865 4.02353 6.52353C4.64865 5.89841 4.99984 5.05056 4.99984 4.1665M14.9998 15.8332C14.9998 14.9491 15.351 14.1013 15.9761 13.4761C16.6013 12.851 17.4491 12.4998 18.3332 12.4998",
    stroke: "#002E6C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsMoney);
export default __webpack_public_path__ + "static/media/akar_icons_money.a23febadb5de8ca56c11f24884e65b5a.svg";
export { ForwardRef as ReactComponent };